module.exports = __webpack_public_path__ + "static/colored_ig_icon-73b041032d2e45a6f01de103548ddd06.png";